import React, { useState } from 'react';
import {
  TabContent, TabPane, Nav, NavItem, NavLink,
} from 'reactstrap';
import classnames from 'classnames';
import TestReleasePanel from './TestReleasePanel';
import ProductionReleasePanel from './ProductionReleasePanel';
import OneBoxReleasePanel from './OneBoxReleasePanel';

const TABS = Object.freeze({
  ONE_BOX: 0,
  INTERNAL: 1,
  BETA: 2,
  PRODUCTION: 3,
});

const TEST_GROUP = Object.freeze({
  INTERNAL: 'internal',
  BETA: 'beta',
});

export default () => {
  const [activeTab, setActiveTab] = useState(TABS.ONE_BOX);

  return (
    <div>
      <Nav tabs>
        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === TABS.ONE_BOX })}
            onClick={() => setActiveTab(TABS.ONE_BOX)}
          >
            One box
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === TABS.INTERNAL })}
            onClick={() => setActiveTab(TABS.INTERNAL)}
          >
            Internal
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === TABS.BETA })}
            onClick={() => setActiveTab(TABS.BETA)}
          >
            Beta
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === TABS.PRODUCTION })}
            onClick={() => setActiveTab(TABS.PRODUCTION)}
          >
            Production
          </NavLink>
        </NavItem>
      </Nav>
      <TabContent activeTab={activeTab}>
        <TabPane tabId={TABS.ONE_BOX}>
          <OneBoxReleasePanel />
        </TabPane>
        <TabPane tabId={TABS.INTERNAL}>
          <TestReleasePanel testGroupName={TEST_GROUP.INTERNAL} />
        </TabPane>
        <TabPane tabId={TABS.BETA}>
          <TestReleasePanel testGroupName={TEST_GROUP.BETA} />
        </TabPane>
        <TabPane tabId={TABS.PRODUCTION}>
          <ProductionReleasePanel />
        </TabPane>
      </TabContent>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/ota/ota.js